
export default class {
    constructor() {        
        $('.events-counttext').html($('#showcount').val());
    }    
}